import RoiCalc from '@zg-rentals/rg-widgets-roi-calc';
import React from 'react';

var RentalRoiCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var heading = attrs.heading,
      subheading = attrs.subheading,
      itc = attrs.itc,
      t = attrs.t;
    var defaultValues = {
      heading: heading,
      subheading: subheading,
      itc: itc,
      t: t
    };
    return /*#__PURE__*/React.createElement(RoiCalc, defaultValues);
  },
  metadata: {
    version: '1.0',
    name: 'zg-rentals/rg-widgets-roi-calc',
    title: 'ZG ROI Calculator',
    description: 'Calculate ROI on rental property to see the gross yield, cap rate, one-year cash return and annual return on investment.',
    icon: 'calculators',
    keywords: ['roi', 'rental', 'calculator'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'widgets',
    attributes: {
      heading: {
        type: 'string',
        default: 'Rental Property ROI Calculator'
      },
      subheading: {
        type: 'string',
        default: 'Calculate your potential return on investment.'
      },
      itc: {
        type: 'string'
      },
      t: {
        type: 'string'
      }
    }
  }
};
var RentalRoiCalculatorBlock$1 = RentalRoiCalculatorBlock;

export { RentalRoiCalculatorBlock$1 as default };
